import { connect } from 'react-redux';
import { Pagination } from '@beef/ui-kit';
import PropTypes from 'prop-types';

import { updateCatalogProducts } from 'store/ProductCatalog/actions';
import { getCatalogFullUrlComposer } from 'store/ProductCatalog/filters/selectors';
import {
  getCatalogCurrentPage,
  getCatalogTotalPages,
} from 'store/ProductCatalog/products/selectors';

const mapStateToProps = (state) => ({
  current: getCatalogCurrentPage(state),
  getHref: getCatalogFullUrlComposer(state),
  total: getCatalogTotalPages(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (e) => {
    dispatch(updateCatalogProducts({ page: e.current }));
  },
});

const PaginationWidget = connect(mapStateToProps, mapDispatchToProps)(Pagination);

PaginationWidget.propTypes = {
  isCompact: PropTypes.bool,
};

export default PaginationWidget;
